import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MetadataService } from '../metadata/metadata.service';
import { Observable, catchError, throwError } from 'rxjs';
import { DateTime } from 'luxon';

function formatDateOnly(dateStr: string): string {
    const fromIso = DateTime.fromISO(dateStr);
    const date = DateTime.utc(fromIso.year, fromIso.month, fromIso.day);
    return date.toISODate();
}

function formatTimeOnly(timeStr: string): string {
    // Placeholder: implement the actual formatting logic
    // 'HH:mm:ss'
    return timeStr;
}

function transformRequestBody(body: any, metadata: any): any {
    // Clone the body to avoid mutating the original request
    const modifiedBody = JSON.parse(JSON.stringify(body));

    // Apply transformations based on metadata
    metadata.dateOnlyFields?.forEach((field: string) => {
        if (modifiedBody.hasOwnProperty(field)) {
            modifiedBody[field] = formatDateOnly(modifiedBody[field]);
        }
    });

    metadata.timeOnlyFields?.forEach((field: string) => {
        if (modifiedBody.hasOwnProperty(field)) {
            modifiedBody[field] = formatTimeOnly(modifiedBody[field]);
        }
    });

    return modifiedBody;
}

export const dateInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const metadataService = inject(MetadataService);

    // Clone the request object
    let newReq = req.clone();

    const endpointMetadata = metadataService.getMetadataForEndpoint(req.url);

    if (req.body && endpointMetadata) {
        const modifiedBody = transformRequestBody(req.body, endpointMetadata);
        newReq = req.clone({ body: modifiedBody });
    }

    // Response
    return next(newReq).pipe(
        catchError((error) => {
            return throwError(() => error);
        })
    );
};
